import { NgModule } from '@angular/core';
import { MsCheckboxComponent } from './ms-checkbox.component';
import { SharedLibsModule } from 'app/shared/shared-libs.module';

@NgModule({
	declarations: [MsCheckboxComponent],
	imports: [SharedLibsModule],
	exports: [MsCheckboxComponent],
	providers: [],
})
export class MsCheckboxModule {}
